// store.jsx
import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';

import supportrequestReducer from "./supportrequestSlice";
import baseurlReducer from "./baseurlSlice";
import draftReducer from "./draftSlice";
import modalReducer from "./modalSlice";
import userReducer from "./userSlice";
import chatReducer from "./chatSlice";
import posReducer from "./posSlice"; // Import the new POS slice

// Persist configuration
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['drafts', 'pos'], // Persist both drafts and POS state
  // Optional: Transform to handle complex objects
  transforms: [
    // Add any custom transforms if needed
  ],
};

const rootReducer = combineReducers({
  supportrequest: supportrequestReducer,
  baseUrl: baseurlReducer,
  drafts: draftReducer,
  modaldraft: modalReducer,
  users: userReducer,
  chats: chatReducer,
  pos: posReducer, // Add POS reducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
        // Ignore non-serializable values in cart (like functions if any)
        ignoredPaths: ['pos.cart'], // Adjust based on your cart structure
      },
    }),
});

export const persistor = persistStore(store);
export default store;